import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    api.get("/auth/me").then((r) => { setUser(r.data.user); setPermissions(r.data.permissions); }).catch(() => { localStorage.removeItem(TOKEN_KEY); setUser(false); });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    setPermissions(data.permissions);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    setPermissions([]);
  }, []);

  const can = useCallback((perm) => permissions.includes(perm), [permissions]);
  return <AuthCtx.Provider value={{ user, permissions, login, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
